import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxSignsExpired from "./_components/BoxSignsExpired";

const SignsExpired = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxSignsExpired />
    </ContentWrapper>
  </>
);

export default SignsExpired;
